import { TaskFieldTypeEnum } from '../../../../screens/admin/admin-console/admin-console-content-pages/admin-console-volunteer-profile/admin-console-volunteer-profile-model';

type RefereeCheckHardCodedFields = {
  [key: string]: {
    optional: boolean;
    __typename: TaskFieldTypeEnum;
    name: string;
    description?: string;
  };
};

export const refereeCheckHardCodedFields: RefereeCheckHardCodedFields = {
  refereeName: {
    optional: false,
    __typename: 'VOLUNTEER_ShortTextTaskFieldType',
    name: 'Referee Name',
    description: 'Full name of the referee',
  },
  refereeEmail: {
    optional: false,
    __typename: 'VOLUNTEER_EmailTaskFieldType',
    name: 'Referee Email',
    description: 'Email address where the referee can be contacted',
  },
  refereePhone: {
    optional: true,
    __typename: 'VOLUNTEER_PhoneTaskFieldType',
    name: 'Referee Phone Number',
    description: 'Phone number for the referee (optional)',
  },
};